var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
/**
 * This HOC giving the component
 * - onChange -> handle if user still pass onValueChange, which is deprecated.
 * - value -> handle if user pass defaultValue, which is deprecated
 * @param {*} WrapperComponent : React.Element
 *
 * Also Useful for Storybook component, which also giving self manage value to the component.
 */
export default function withFieldLocalValue(WrapperComponent) {
    class Comp extends React.Component {
        constructor(props) {
            super(props);
            this.handleChange = (value, ...rest) => {
                const { onChange, onValueChange } = this.props;
                if (__DEV__) {
                    if (onValueChange) {
                        console.warn('onValueChange is deprecated. Use onChange instead!');
                    }
                }
                // only update local state if it's uncontrolled
                if (this.isControlled === false) {
                    this.setState({ value });
                }
                onChange && onChange(value, ...rest);
                onValueChange && onValueChange(value, ...rest);
            };
            if (__DEV__) {
                if (props.initialValue) {
                    console.warn('initialValue is deprecated. Use defaultValue instead!');
                }
            }
            // Controlled means the parent *controls* the value, so we
            // shouldn't use local state.
            //
            // The opposite (uncontrolled) means the parent only needs to provide us with
            // a default/initial value. The rest should be handled with local state.
            const { value, initialValue, defaultValue } = props;
            this.isControlled =
                typeof value !== 'undefined' && typeof initialValue === 'undefined' && typeof defaultValue === 'undefined';
            if (this.isControlled === false) {
                this.state = {
                    value: props.defaultValue || props.initialValue,
                };
            }
        }
        render() {
            const _a = this.props, { onChange, onValueChange } = _a, rest = __rest(_a, ["onChange", "onValueChange"]);
            return (<WrapperComponent {...rest} value={this.isControlled ? this.props.value : this.state.value} onChange={this.handleChange} onValueChange={this.handleChange}/>);
        }
    }
    return hoistNonReactStatics(Comp, WrapperComponent);
}
